import { useCallback, useEffect, useState } from "react";
import Navbar from "@/components/Navbar";
import DemoModal from "@/components/DemoModal";
import WhatsAppAssistant from "@/components/WhatsAppAssistant";
import CookieBanner from "@/components/CookieBanner";
import VoiceWelcome from "@/components/VoiceWelcome";
import Marquee from "@/components/Marquee";
import Hero from "@/sections/Hero";
import Expertise from "@/sections/Expertise";
import Agents from "@/sections/Agents";
import Xos from "@/sections/Xos";
import Projects from "@/sections/Projects";
import Academy from "@/sections/Academy";
import Method from "@/sections/Method";
import Cta from "@/sections/Cta";
import Footer from "@/sections/Footer";
import Seo from "@/components/Seo";
import { getConfig } from "@/lib/api";
import { useLanguage } from "@/i18n/LanguageContext";

const Landing = () => {
  const { t, lang } = useLanguage();
  const [whatsapp, setWhatsapp] = useState("");
  const [demoOpen, setDemoOpen] = useState(false);
  const openDemo = useCallback(() => setDemoOpen(true), []);

  useEffect(() => {
    getConfig()
      .then((c) => setWhatsapp(c.whatsapp_number || ""))
      .catch(() => {});
  }, []);

  useEffect(() => {
    const handler = (e) => {
      const el = e.target.closest?.(".spotlight");
      if (!el) return;
      const r = el.getBoundingClientRect();
      el.style.setProperty("--mx", `${e.clientX - r.left}px`);
      el.style.setProperty("--my", `${e.clientY - r.top}px`);
    };
    window.addEventListener("mousemove", handler);
    return () => window.removeEventListener("mousemove", handler);
  }, []);

  const waLink = useCallback(
    (text) =>
      `https://wa.me/${(whatsapp || "41782042172").replace(/\D/g, "")}?text=${encodeURIComponent(text)}`,
    [whatsapp]
  );

  return (
    <div className="bg-void text-white font-body min-h-screen" id="top">
      <Seo title={t.meta.title} description={t.meta.description} path="/" lang={lang} />
      <div className="grain-overlay" />
      <Navbar onOpenDemo={openDemo} waLink={waLink} />
      <main>
        <Hero onOpenDemo={openDemo} waLink={waLink} />
        <Marquee />
        <Expertise />
        <Agents />
        <Xos />
        <Projects />
        <Academy waLink={waLink} />
        <Method />
        <Cta onOpenDemo={openDemo} waLink={waLink} />
      </main>
      <Footer waLink={waLink} />
      <WhatsAppAssistant whatsapp={whatsapp} />
      <VoiceWelcome />
      <CookieBanner />
      <DemoModal open={demoOpen} onClose={() => setDemoOpen(false)} />
    </div>
  );
};

export default Landing;
